import React from 'react';
import PropTypes from 'prop-types';

import './ContentBlockEditor.css';

import Select from 'react-select';
import FormField from '../FormField/FormField';

// Some decent UI to visualize and edit content blocks
// Type takes values 'content' or 'showcase'
// Layout takes values 'A' or 'B' for both types
// This brings the total permutations to 4
// Also takes a content prop (mandatory)
class ContentBlockEditor extends React.Component {
  static propTypes = {
    category: PropTypes.string.isRequired,
    // Optional code for targetting employees
    personCode: PropTypes.string,
    blockNumber: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    layout: PropTypes.string.isRequired,
    header: PropTypes.string.isRequired,
    content: PropTypes.array.isRequired,
    blogPosts: PropTypes.array,
    onChangeBlockHeader: PropTypes.func.isRequired,
    onChangeCellType: PropTypes.func.isRequired,
    onChangeCellContent: PropTypes.func.isRequired,
    onSelectCellContent: PropTypes.func.isRequired,
    onAddCarouselPhoto: PropTypes.func.isRequired,
    onRemoveCarouselPhoto: PropTypes.func.isRequired
  };

  state = {

  };

  _renderFields = (cellIndex, cellType) => {
    const {
      category,
      personCode,
      blockNumber,
      content,
      blogPosts,
      onChangeCellContent,
      onSelectCellContent,
      onAddCarouselPhoto,
      onRemoveCarouselPhoto
    } = this.props;
    const targetContent = content[cellIndex];

    switch (cellType) {
      case 'photo-small':
        return (
          <div className='ContentBlockEditor-fieldContainer'>
            <FormField 
              nomargin
              type='text' 
              name='photo'
              placeholder='Photo URL'
              value={targetContent ? targetContent.photo : ''}
              onChange={(event) => onChangeCellContent({category, personCode, blockNumber, cellIndex, event})}
            />
            <FormField
              nomargin
              type='text'
              name='url'
              placeholder='External link attached (optional)'
              value={targetContent ? targetContent.url : ''}
              onChange={(event) => onChangeCellContent({category, personCode, blockNumber, cellIndex, event})}
            />
            <FormField
              type='text'
              name='caption'
              placeholder='Photo caption (optional)'
              value={targetContent ? targetContent.caption : ''}
              onChange={(event) => onChangeCellContent({category, personCode, blockNumber, cellIndex, event})}
            />
          </div>
        );
      case 'photo-large':
        return (
          <div className='ContentBlockEditor-fieldContainer'>
            <FormField
              nomargin
              type='text'
              name='photo'
              placeholder='Photo URL'
              value={targetContent.photo}
              onChange={(event) => onChangeCellContent({category, personCode, blockNumber, cellIndex, event})}
            />
            <FormField
              nomargin
              type='text'
              name='url'
              placeholder='External link attached (optional)'
              value={targetContent.url}
              onChange={(event) => onChangeCellContent({category, personCode, blockNumber, cellIndex, event})}
            />
            <FormField
              nomargin
              type='text'
              name='caption'
              placeholder='Photo caption (optional)'
              value={targetContent.caption}
              onChange={(event) => onChangeCellContent({category, personCode, blockNumber, cellIndex, event})}
            />
          </div>
        );
      case 'photo-carousel':
        return (
          <div>
            {
              targetContent.photos.map((photo, index) => (
              <div key={`photocarousel-${index}`} className='ContentBlockEditor-fieldContainer'>
                <FormField
                  nomargin
                  type='text'
                  name={`carouselphoto${index}`}
                  placeholder={`Photo ${index + 1} URL`}
                  value={targetContent.photos[index]}
                  onChange={(event) => onChangeCellContent({category, personCode, blockNumber, cellIndex, event})}
                />
                <FormField
                  nomargin
                  type='text'
                  name={`carouselphoto-caption${index}`}
                  placeholder={`Photo ${index + 1} caption`}
                  value={targetContent.captions[index]}
                  onChange={(event) => onChangeCellContent({category, personCode, blockNumber, cellIndex, event})}
                />
              </div>
            ))
            }
            <div className='ContentBlockEditor-buttonContainer'>
              {
                targetContent.photos.length > 0 &&
                <button className='ContentBlockEditor-removeButton' type='button' onClick={() => onRemoveCarouselPhoto({category, personCode, blockNumber, cellIndex})}>
                  <i className='fa fa-minus-circle' />
                  {' '}Remove Photo
                </button>
              }
              {
                targetContent.photos.length < 6 &&
                <button className='ContentBlockEditor-addButton' type='button' onClick={() => onAddCarouselPhoto({category, personCode, blockNumber, cellIndex})}>
                  <i className='fa fa-plus-circle' />
                  {' '}Add Photo
                </button>
              }
            </div>
          </div>
        );
      case 'video-medium':
        return (
          <div className='ContentBlockEditor-fieldContainer'>
            <FormField
              nomargin
              type='number'
              name='video'
              placeholder='Vimeo id of video (e.g. 231662921)'
              value={targetContent.video}
              onChange={(event) => onChangeCellContent({category, personCode, blockNumber, cellIndex, event})}
            />
            <FormField
              nomargin
              type='text'
              name='caption'
              placeholder='Video caption (optional)'
              value={targetContent.caption}
              onChange={(event) => onChangeCellContent({category, personCode, blockNumber, cellIndex, event})}
            />
          </div>
        );
      case 'video-large':
        return (
          <div className='ContentBlockEditor-fieldContainer'>
          <FormField
            nomargin
            type='number'
            name='video'
            placeholder='Vimeo id of video (e.g. 231662921)'
            value={targetContent.video}
            onChange={(event) => onChangeCellContent({category, personCode, blockNumber, cellIndex, event})}
          />
          <FormField
            nomargin
            type='text'
            name='caption'
            placeholder='Video caption (optional)'
            value={targetContent.caption}
            onChange={(event) => onChangeCellContent({category, personCode, blockNumber, cellIndex, event})}
          />
        </div>
        );
      case 'video-huge':
        return (
          <div className='ContentBlockEditor-fieldContainer'>
            <FormField
              nomargin
              type='number'
              name='video'
              placeholder='Vimeo id of video (e.g. 231662921)'
              value={targetContent.video}
              onChange={(event) => onChangeCellContent({category, personCode, blockNumber, cellIndex, event})}
            />
            <FormField
              nomargin
              type='text'
              name='caption'
              placeholder='Video caption (optional)'
              value={targetContent.caption}
              onChange={(event) => onChangeCellContent({category, personCode, blockNumber, cellIndex, event})}
            />
          </div>
        );
      case 'paragraph-small':
        return (
          <div className='ContentBlockEditor-fieldContainer'>
            <FormField
              nomargin
              type='text'
              name='header'
              placeholder='Optional paragraph header'
              value={targetContent.header}
              onChange={(event) => onChangeCellContent({category, personCode, blockNumber, cellIndex, event})}
            />
            <FormField
              nomargin
              type='textarea'
              name='text'
              placeholder='Paragraph text'
              value={targetContent.text}
              onChange={(event) => onChangeCellContent({category, personCode, blockNumber, cellIndex, event})}
            />
          </div>
        );
      case 'paragraph-medium':
        return (
          <div className='ContentBlockEditor-fieldContainer'>
            <FormField
              nomargin
              type='text'
              name='header'
              placeholder='Optional paragraph header'
              value={targetContent.header}
              onChange={(event) => onChangeCellContent({category, personCode, blockNumber, cellIndex, event})}
            />
            <FormField
              nomargin
              type='textarea'
              name='text'
              placeholder='Paragraph text'
              value={targetContent.text}
              onChange={(event) => onChangeCellContent({category, personCode, blockNumber, cellIndex, event})}
            />
          </div>
        );
      case 'paragraph-huge':
        return (
          <div className='ContentBlockEditor-fieldContainer'>
            <FormField
              nomargin
              type='text'
              name='header'
              placeholder='Optional paragraph header'
              value={targetContent.header}
              onChange={(event) => onChangeCellContent({category, personCode, blockNumber, cellIndex, event})}
            />
            <FormField
              nomargin
              type='textarea'
              name='text'
              placeholder='Paragraph text'
              value={targetContent.text}
              onChange={(event) => onChangeCellContent({category, personCode, blockNumber, cellIndex, event})}
            />
          </div>
        );
      case 'address':
        return (
          <div className='ContentBlockEditor-fieldContainer'>
          </div>
        );
      case 'blogpost':
        return (
          <div className='ContentBlockEditor-fieldContainer'>
            <Select
              className='ContentBlockEditor-select'
              name='slug'
              placeholder={blogPosts ? 'Select Blog Post' : 'Loading...'}
              value={targetContent.slug}
              onChange={(option) => onSelectCellContent({category, personCode, blockNumber, cellIndex, data: { slug: option ? option.value: '', title: option ? option.label : '', photo: option ? option.photo : ''  }, name: 'blogpost'})}
              options={blogPosts ? blogPosts.map(post => ({ value: post.slug, label: post.title.rendered, photo: post._embedded['wp:featuredmedia'][0].source_url })) : []}
            />
          </div>
        );
      default:
        return null;
    }
  }

  _renderGrid = () => {
    const { category, personCode, blockNumber, type, layout, content, onChangeCellType } = this.props;

    if (type === 'content') {
      if (layout === 'A') {
        return (
          <div className='ContentBlockEditor-grid'>
            <div className='ContentBlockEditor-col-1'>
              <div className='ContentBlockEditor-row'>
                <Select
                  className='ContentBlockEditor-select'
                  name='celltype'
                  placeholder='Select Content Type...'
                  searchable={false}
                  clearable={false}
                  value={content[0].type}
                  onChange={(option) => onChangeCellType({category, personCode, blockNumber, cellIndex: 0, option})}
                  options={[
                    { value: 'photo-small', label: 'Photo' },
                    { value: 'blogpost', label: 'Blog Article' },
                    { value: 'paragraph-small', label: 'Paragraph (1x1)' },
                    { value: 'paragraph-medium', label: 'Paragraph (1x2)' },
                    { value: 'video-medium', label: 'Portrait Video' }
                  ]}
                />
                { this._renderFields(0, content[0].type) }
              </div>
              {
                (content[0].type !== 'paragraph-medium' && content[0].type !== 'video-medium') &&
                <div className='ContentBlockEditor-row'>
                  <Select
                    className='ContentBlockEditor-select'
                    name='celltype'
                    placeholder='Select Content Type...'
                    searchable={false}
                    clearable={false}
                    value={content[1].type}
                    onChange={(option) => onChangeCellType({category, personCode, blockNumber, cellIndex: 1, option})}
                    options={[
                      { value: 'photo-small', label: 'Photo' },
                      { value: 'blogpost', label: 'Blog Article' },
                      { value: 'paragraph-small', label: 'Paragraph (1x1)' }
                    ]}
                  />
                  { this._renderFields(1, content[1].type) }
                </div>
              }
            </div>
            <div className='ContentBlockEditor-col-1'>
              <div className='ContentBlockEditor-row'>
                <Select
                  className='ContentBlockEditor-select'
                  name='celltype'
                  placeholder='Select Content Type...'
                  searchable={false}
                  clearable={false}
                  value={content[2].type}
                  onChange={(option) => onChangeCellType({category, personCode, blockNumber, cellIndex: 2, option})}
                  options={[
                    { value: 'photo-small', label: 'Photo' },
                    { value: 'blogpost', label: 'Blog Article' },
                    { value: 'paragraph-small', label: 'Paragraph (1x1)' },
                    { value: 'paragraph-medium', label: 'Paragraph (1x2)' },
                    { value: 'video-medium', label: 'Portrait Video' }
                  ]}
                />
                { this._renderFields(2, content[2].type) }
              </div>
              {
                (content[2].type !== 'paragraph-medium' && content[2].type !== 'video-medium') &&
                <div className='ContentBlockEditor-row'>
                  <Select
                    className='ContentBlockEditor-select'
                    name='celltype'
                    placeholder='Select Content Type...'
                    searchable={false}
                    clearable={false}
                    value={content[3].type}
                    onChange={(option) => onChangeCellType({category, personCode, blockNumber, cellIndex: 3, option})}
                    options={[
                      { value: 'photo-small', label: 'Photo' },
                      { value: 'blogpost', label: 'Blog Article' },
                      { value: 'paragraph-small', label: 'Paragraph (1x1)' }
                    ]}
                  />
                  { this._renderFields(3, content[3].type) }
                </div>
              }
            </div>
            <div className='ContentBlockEditor-col-1'>
              <div className='ContentBlockEditor-row'>
                <Select
                  className='ContentBlockEditor-select'
                  name='celltype'
                  placeholder='Select Content Type...'
                  searchable={false}
                  clearable={false}
                  value={content[4].type}
                  onChange={(option) => onChangeCellType({category, personCode, blockNumber, cellIndex: 4, option})}
                  options={[
                    { value: 'photo-small', label: 'Photo' },
                    { value: 'blogpost', label: 'Blog Article' },
                    { value: 'paragraph-small', label: 'Paragraph (1x1)' },
                    { value: 'paragraph-medium', label: 'Paragraph (1x2)' },
                    { value: 'video-medium', label: 'Portrait Video' }
                  ]}
                />
                { this._renderFields(4, content[4].type) }
              </div>
              {
                (content[4].type !== 'paragraph-medium' && content[4].type !== 'video-medium') &&
                <div className='ContentBlockEditor-row'>
                  <Select
                    className='ContentBlockEditor-select'
                    name='celltype'
                    placeholder='Select Content Type...'
                    searchable={false}
                    clearable={false}
                    value={content[5].type}
                    onChange={(option) => onChangeCellType({category, personCode, blockNumber, cellIndex: 5, option})}
                    options={[
                      { value: 'photo-small', label: 'Photo' },
                      { value: 'blogpost', label: 'Blog Article' },
                      { value: 'paragraph-small', label: 'Paragraph (1x1)' }
                    ]}
                  />
                  { this._renderFields(5, content[5].type) }
                </div>
              }
            </div>
          </div>
        );
      } else if (layout === 'B') {
        return (
          <div className='ContentBlockEditor-grid'>
            <div className='ContentBlockEditor-col-1'>
              <div className='ContentBlockEditor-row'>
                <Select
                  className='ContentBlockEditor-select'
                  name='celltype'
                  placeholder='Select Content Type...'
                  searchable={false}
                  clearable={false}
                  value={content[0].type}
                  onChange={(option) => onChangeCellType({category, personCode, blockNumber, cellIndex: 0, option})}
                  options={[
                    { value: 'photo-small', label: 'Photo' },
                    { value: 'blogpost', label: 'Blog Article' },
                    { value: 'paragraph-small', label: 'Paragraph (1x1)' },
                    { value: 'paragraph-medium', label: 'Paragraph (1x2)' },
                    { value: 'video-medium', label: 'Portrait Video' }
                  ]}
                />
                { this._renderFields(0, content[0].type) }
              </div>
              <div className='ContentBlockEditor-row'>
                <Select
                  className='ContentBlockEditor-select'
                  name='celltype'
                  placeholder='Select Content Type...'
                  searchable={false}
                  clearable={false}
                  value={content[1].type}
                  onChange={(option) => onChangeCellType({category, personCode, blockNumber, cellIndex: 1, option})}
                  options={[
                    { value: 'photo-small', label: 'Photo' },
                    { value: 'blogpost', label: 'Blog Article' },
                    { value: 'paragraph-small', label: 'Paragraph (1x1)' }
                  ]}
                />
                { this._renderFields(1, content[1].type) }
              </div>
            </div>
            <div className='ContentBlockEditor-col-2'>
              <div className='ContentBlockEditor-row ContentBlockEditor-row-horizontal'>
                <div className='ContentBlockEditor-row-left'>
                  <Select
                    className='ContentBlockEditor-select'
                    name='celltype'
                    placeholder='Select Content Type...'
                    searchable={false}
                    clearable={false}
                    value={content[2].type}
                    onChange={(option) => onChangeCellType({category, personCode, blockNumber, cellIndex: 2, option})}
                    options={[
                      { value: 'photo-small', label: 'Photo' },
                      { value: 'blogpost', label: 'Blog Article' },
                      { value: 'paragraph-medium', label: 'Paragraph (2x1)' },
                      { value: 'paragraph-small', label: 'Paragraph (1x1)' }
                    ]}
                  />
                  { this._renderFields(2, content[2].type) }
                </div>
                {
                  content[2].type !== 'paragraph-medium' &&
                  <div className='ContentBlockEditor-row-right'>
                    <Select
                      className='ContentBlockEditor-select'
                      name='celltype'
                      placeholder='Select Content Type...'
                      searchable={false}
                      clearable={false}
                      value={content[3].type}
                      onChange={(option) => onChangeCellType({category, personCode, blockNumber, cellIndex: 3, option})}
                      options={[
                        { value: 'photo-small', label: 'Photo' },
                        { value: 'blogpost', label: 'Blog Article' },
                        { value: 'paragraph-small', label: 'Paragraph (1x1)' }
                      ]}
                    />
                    { this._renderFields(3, content[3].type) }
                  </div>
                }
              </div>
              <div className='ContentBlockEditor-row ContentBlockEditor-row-horizontal'>
                <div className='ContentBlockEditor-row-left'>
                  <Select
                    className='ContentBlockEditor-select'
                    name='celltype'
                    placeholder='Select Content Type...'
                    searchable={false}
                    clearable={false}
                    value={content[4].type}
                    onChange={(option) => onChangeCellType({category, personCode, blockNumber, cellIndex: 4, option})}
                    options={[
                      { value: 'photo-small', label: 'Photo' },
                      { value: 'blogpost', label: 'Blog Article' },
                      { value: 'paragraph-medium', label: 'Paragraph (2x1)' },
                      { value: 'paragraph-small', label: 'Paragraph (1x1)' }
                    ]}
                  />
                  { this._renderFields(4, content[4].type) }
                </div>
                {
                  content[4].type !== 'paragraph-medium' &&
                  <div className='ContentBlockEditor-row-right'>
                    <Select
                      className='ContentBlockEditor-select'
                      name='celltype'
                      placeholder='Select Content Type...'
                      searchable={false}
                      clearable={false}
                      value={content[5].type}
                      onChange={(option) => onChangeCellType({category, personCode, blockNumber, cellIndex: 5, option})}
                      options={[
                        { value: 'photo-small', label: 'Photo' },
                        { value: 'blogpost', label: 'Blog Article' },
                        { value: 'paragraph-small', label: 'Paragraph (1x1)' }
                      ]}
                    />
                    { this._renderFields(5, content[5].type) }
                  </div>
                }
              </div>
            </div>
          </div>
        );
      }
      return null
    } else if (type === 'showcase') {
      if (layout === 'A') {
        return (
          <div className='ContentBlockEditor-grid'>
            <div className='ContentBlockEditor-col-3'>
              <Select
                className='ContentBlockEditor-select'
                name='celltype'
                placeholder='Select Content Type...'
                searchable={false}
                clearable={false}
                value={content[0].type}
                onChange={(option) => onChangeCellType({category, personCode, blockNumber, cellIndex: 0, option})}
                options={[
                  { value: 'video-huge', label: 'Landscape video' },
                  { value: 'paragraph-huge', label: 'Paragraph' }
                ]}
              />
              { this._renderFields(0, content[0].type) }
            </div>
          </div>
        );
      } else if (layout === 'B') {
        return (
          <div className='ContentBlockEditor-grid'>
            <div className='ContentBlockEditor-col-2'>
              <div className='ContentBlockEditor-row'>
                <Select
                  className='ContentBlockEditor-select'
                  name='celltype'
                  placeholder='Select Content Type...'
                  searchable={false}
                  clearable={false}
                  value={content[0].type}
                  onChange={(option) => onChangeCellType({category, personCode, blockNumber, cellIndex: 0, option})}
                  options={[
                    { value: 'photo-large', label: 'Showcase photo' },
                    { value: 'photo-carousel', label: 'Carousel photos with captions' },
                    { value: 'video-large', label: 'Showcase video with caption' }
                  ]}
                />
                { this._renderFields(0, content[0].type) }
              </div>
            </div>
            <div className='ContentBlockEditor-col-1'>
              <div className='ContentBlockEditor-row'>
                <Select
                  className='ContentBlockEditor-select'
                  name='celltype'
                  placeholder='Select Content Type...'
                  searchable={false}
                  clearable={false}
                  value={content[1].type}
                  onChange={(option) => onChangeCellType({category, personCode, blockNumber, cellIndex: 1, option})}
                  options={[
                    { value: 'photo-small', label: 'Photo' },
                    { value: 'blogpost', label: 'Blog Article' },
                    { value: 'address', label: 'Company Address' }
                  ]}
                />
                { this._renderFields(1, content[1].type) }
              </div>
              <div className='ContentBlockEditor-row'>
                <Select
                  className='ContentBlockEditor-select'
                  name='celltype'
                  placeholder='Select Content Type...'
                  searchable={false}
                  clearable={false}
                  value={content[2].type}
                  onChange={(option) => onChangeCellType({category, personCode, blockNumber, cellIndex: 2, option})}
                  options={[
                    { value: 'photo-small', label: 'Photo' },
                    { value: 'blogpost', label: 'Blog Article' },
                    { value: 'address', label: 'Company Address' }
                  ]}
                />
                { this._renderFields(2, content[2].type) }
              </div>
            </div>
          </div>
        );
      }
      return null
    }
    return null;
  }

  render() {
    const { blockNumber, type, layout, header, onChangeBlockHeader } = this.props;

    return (
      <div className='ContentBlockEditor-root'>
        <p className='ContentBlockEditor-title'>
          Content for Block {blockNumber + 1}
        </p>
        {
          type === 'content' && layout &&
          <FormField
            type='text'
            placeholder='Optional Header'
            value={header}
            onChange={onChangeBlockHeader}
          />
        }
        {type && layout && this._renderGrid()}
      </div>
    );
  }
}

export default ContentBlockEditor;



// WEBPACK FOOTER //
// ./src/components/contentform/ContentBlockEditor/ContentBlockEditor.js